import IRequest from "../../IRequest"
import { TProduto } from "./produtos"

export type TCategoria = {
    id: number,
    nome: string,
    subcategorias?: TCategoria[]
    produtos?: TProduto[]
}

export interface ICategorias {
    reqCategorias: IRequest<TCategoria>,
    dataCategorias: TCategoria[]
}

export const defValueCategoriaComercial: TCategoria = 
{
  id: 0,
  nome: ''
}